export const campaignEndpoints = (builder) => ({
    createCampaign: builder.mutation({
        query: (data) => ({url: `/campaigns`, method: 'post', body: data}),
        invalidatesTags: ['Campaign'],
    }),
    updateCampaign: builder.mutation({
        query: ({ id, ...data }) => ({ url: `/campaigns/${id}`, method: 'patch', body: { ...data } }),
        invalidatesTags: ['Campaign'],
    }),
    deleteCampaign: builder.mutation({
        query: ({ id, ...data }) => ({ url: `/campaigns/${id}`, method: 'delete', body: { ...data } }),
        invalidatesTags: ['Campaign'],
    }),
    
})